import { render, staticRenderFns } from "./Rizhi.vue?vue&type=template&id=1f652c8a&scoped=true"
import script from "./Rizhi.vue?vue&type=script&lang=js"
export * from "./Rizhi.vue?vue&type=script&lang=js"
import style0 from "./Rizhi.vue?vue&type=style&index=0&id=1f652c8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f652c8a",
  null
  
)

export default component.exports